import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { axiosInt } from '../../../utils';
import { API_IDENTITY_URL } from '../../../utils';
import type { IUser } from '../../../types/user';
import type { IBaseTableParams, IPaginateData } from '../../../types';

export const FETCH_ORGANIZATION_USERS_KEY = 'fetchOrganizationUsers';
export const fetchOrganizationUsers = async (
  organizationId: string,
  params: IBaseTableParams
): Promise<IPaginateData<IUser>> => {
  const response = await axiosInt.get(
    `${API_IDENTITY_URL}/users/organization/${organizationId}`,
    { params }
  );
  return response.data;
};

const useFetchOrganizationUsers = (
  organizationId: string,
  params: IBaseTableParams,
  options?: Partial<UseQueryOptions<IPaginateData<IUser>>>
) => {
  const {
    data: organizationUsers,
    isLoading: isLoadingOrganizationUsers,
    error: errorFetchingOrganizationUsers,
  } = useQuery<IPaginateData<IUser>>({
    queryKey: [FETCH_ORGANIZATION_USERS_KEY, organizationId, params],
    queryFn: () => fetchOrganizationUsers(organizationId, params),
    enabled: !!organizationId && !!params,
    placeholderData: prev => prev,
    ...options,
  });

  return {
    organizationUsers,
    isLoadingOrganizationUsers,
    errorFetchingOrganizationUsers,
  };
};

export default useFetchOrganizationUsers;
